import React, { lazy } from 'react';
import { MoonIcon, ActivityIcon, GaugeIcon, CloudRainIcon, SearchXIcon, BatteryLowIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const PAIN_IMG = 'https://cdn.magicpatterns.com/uploads/eV3j7g2Ps3DkLs1NYncXvg/dolor.webp';
const painPoints = [{
  icon: MoonIcon,
  text: 'Te despiertas cansada aunque hayas dormido'
}, {
  icon: ActivityIcon,
  text: 'Tu cuerpo está inflamado sin razón aparente'
}, {
  icon: GaugeIcon,
  text: 'Tu metabolismo parece haberse detenido'
}, {
  icon: CloudRainIcon,
  text: 'Los cambios de humor controlan tu vida'
}, {
  icon: SearchXIcon,
  text: 'Sientes que probaste todo y nada funciona'
}, {
  icon: BatteryLowIcon,
  text: 'Tu energía desaparece antes del mediodía'
}];
export function PainSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-133" data-mp="22a9s61uwzi4x">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-134" data-mp="278ui98ggclfn">
        <Reveal className="order-2 lg:order-1" data-id="element-135" data-mp="3rlzhtd3aw1nv">
          <div className="overflow-hidden rounded-3xl shadow-xl shadow-tinta/10" data-id="element-136" data-mp="3rovg52j28scu">
            <img src={PAIN_IMG} alt="Mujer cansada mirando por la ventana en un día lluvioso, sosteniendo una taza" className="h-full max-h-[560px] w-full object-cover" loading="lazy" data-id="element-137" data-mp="3nl5vgo5iaux3" />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2" data-id="element-138" data-mp="38x2md5w63342">
          <Reveal data-id="element-139" data-mp="33xg6eooyf8rk">
            <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-140" data-mp="33xyc0bxiazc5">
              ¿Te identificas con esto?
            </h2>
          </Reveal>

          <ul className="mt-8 space-y-4" data-id="element-141" data-mp="3dvmbtg9yyx16">
            {painPoints.map((p, i) => <Reveal as="li" key={p.text} delay={i * 0.07} data-id="element-142" data-mp="3dtt1nr05duof" data-mpi={i}>
                <div className="flex items-start gap-4 rounded-2xl bg-crema/70 p-4 sm:p-5" data-id="element-143" data-mp="2q4qmcpszkdx3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rosa/15 text-rosa-dark" data-id="element-144" data-mp="2l5xaf1tckuz1">
                    <p.icon className="h-5 w-5" strokeWidth={1.7} data-id="element-145" data-mp="p3k3o1yaqs0i" />
                  </span>
                  <span className="pt-2 text-base leading-snug text-tinta/85 sm:text-lg" data-id="element-146" data-mp="u12dduk51b9k">
                    {p.text}
                  </span>
                </div>
              </Reveal>)}
          </ul>

          <Reveal delay={0.2} data-id="element-147" data-mp="12xba31gqdvs0">
            <p className="mt-8 text-lg leading-relaxed text-tinta/70" data-id="element-148" data-mp="65hixzcs7h8i">
              No estás sola, ni te estás inventando nada. Tu cuerpo te está
              hablando y merece que lo escuches.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}